module.exports = __webpack_public_path__ + "static/img/fullscreen-image_hero_600.2427ceb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/live-hr-advice/fullscreen-image_hero_600.png
// module id = tFQn
// module chunks = 0